/**
 * Locale BCP-47 dérivée de la langue active de l'application.
 *
 * Lue **synchronement** depuis `<html lang>` (posé par
 * `LanguageService.updateHtmlAttributes`), avec repli sur `localStorage['userLang']`
 * puis `'fr'`. Cela permet aux formateurs de dates **purs** (mappers, utils sans
 * injection de service) de produire des libellés (mois, jours) traduits selon la
 * langue courante, sans devoir plomber un service dans chaque appelant.
 *
 * @returns `'fr-FR'` (défaut) ou `'en-GB'` si la langue active est l'anglais.
 */
export function currentDateLocale(): string {
  let lang = 'fr';
  try {
    const htmlLang =
      typeof document !== 'undefined'
        ? document.documentElement.getAttribute('lang')
        : null;
    const stored =
      typeof localStorage !== 'undefined' ? localStorage.getItem('userLang') : null;
    lang = (htmlLang || stored || 'fr').toLowerCase();
  } catch {
    lang = 'fr';
  }
  return lang.startsWith('en') ? 'en-GB' : 'fr-FR';
}
